//import InvitationHandler from './InvitationHandler';
import GlobalVariables from './core/GlobalVariables';
import isMobile from './isMobile';
import { isTabletOrIpad } from './isTabletOrIpad';

export default function ApexChatInit() {
    try {
        //  window.ApexChat = window.ApexChat || {};
        // make sure this only runs once
        if (window.ApexChat && window.ApexChat.invitationv2run) {
            return;
        }

        window.ApexChat = window.ApexChat || {};
        window.ApexChat.invitationv2run = true;

        const fromQueryString = function (key) {
            const parts = window.location.search.substring(1).split('&');
            for (let i = 0; i < parts.length; i++) {
                const pair = parts[i].split('=');
                if (pair[0] == key) {
                    return pair[1];
                }
            }
            return '';
        };

        const readCookie = function (name) {
            const nameEQ = `${name}=`;
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        };

        const readCookieValue = function (cookieName) {
            if (!cookieName) return;
            const prefix = cookieName.substring(0, 9);
            if (prefix === 'livechat_') {
                cookieName = cookieName.substring(prefix.length, cookieName.length);
                return readCookie(`apexchat_${cookieName}`) || readCookie(`livechat_${cookieName}`);
            }
            return readCookie(cookieName);
        };

        const createCookie = function (name, value, minutes) {
            if (minutes) {
                const date = new Date();
                date.setTime(date.getTime() + minutes * 60 * 1000);
                var expires = `; expires=${date.toGMTString()}`;
            } else var expires = '';
            document.cookie = `${name}=${value}${expires}; path=/`;
        };

        const applyTo = function (o1, o2) {
            for (const prop in o2) {
                if (o2.hasOwnProperty(prop)) {
                    o1[prop] = o2[prop];
                }
            }
        };

        const deleteCookie = function (name, value, days) {
            let expires;
            if (name) {
                if (days) {
                    const date = new Date();
                    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                    expires = `; expires=${date.toGMTString()}`;
                } else {
                    expires = '';
                }
                document.cookie = `${name}=${escape(value)}${expires}; path=/`;
            }
        };
        // todo: We need to remove this line of code in future
        deleteCookie('apexchat_chat_id', '', -1);
        const invitationConfiguration = async function () {
            // ok, we have loaded the baseline
            // store the profile id, and select and store the agent id

            // initialize the invitation
            // note that this is now responsible for:
            // -picking the sms number
            // -setting the business open/closed indicator based on hours of operation
            // -selecting the agent alias and handler url
            // console.log('Loaded ' + script.src);
            if (ApexChat.Invitation) {
                if (ApexChat.Invitation.config) {
                    // slim overrides apply to the config
                    // primarily, this will be the profile id
                    if (ApexChat.slimInit) {
                        applyTo(ApexChat.Invitation.config, ApexChat.slimInit);
                    }
                    const domain = GlobalVariables.CdnBaseUrl
                        ? `${GlobalVariables.CdnBaseUrl}`
                        : options.domain;
                    __webpack_public_path__ = `${domain}contents/scripts/dist/`;
                    const module = await import(/* webpackChunkName: "invitationHandler" */ './InvitationHandler')
                    const InvitationHandler = module.default;
                    // initialize the invite
                    const inv = new InvitationHandler().init(ApexChat.Invitation.config);

                    // MOVE ME
                    // if (!visitorGuid) {
                    //    visitorGuid = ApexChat.slimInit.randomGuid;
                    //    createCookie(VISITOR_HISTORY_COOKIE, visitorGuid, 365);
                    // }

                    // after showing the invite, we trigger a secondary tracker that logs the visit independently of the load of the main script
                    // visitor id is zero on first load as in this mode, we don't track the visitor until later
                    // load up all the config info from the invitation itself, which knows what it showed
                }
                // check if company is BETA then BETA pingHandler should be used.
                let pingHandlerDomain = domain;
                const optionData = ApexChat.options || ApexChat.Invitation.options; // either V2 or V3
                if (
                    optionData &&
                    optionData.domain &&
                    optionData.domain.indexOf(GlobalVariables.ApexChatBetaUrl) !== -1
                ) {
                    // make sure its beta
                    // we avoided writing logic inside PingHandler.ashx to redirect on beta. we are handling from here.
                    pingHandlerDomain = `${document.location.protocol}//${GlobalVariables.ApexChatBetaUrl}/`;
                }
                var url = `${GlobalVariables.ApexChatBaseUrl}api/invitations/ping?company=${companyId}&ecid=${optionData.ecid
                    // '&visitorGuid=' + visitorGuid +
                    }&visitorId=${visitorId}&agentAliasId=${optionData.agentAliasId
                    }&operatorId=${optionData.operatorId}&profileId=${optionData.profileId
                    }&chatId=${readCookieValue(
                        CHATID_COOKIE
                    )}&invitationVersion=${optionData.invitationVersion}&chatMode=${optionData.chatMode
                    }&originalReferrer=${encodeURIComponent(document.referrer).substring(
                        0,
                        500
                    )}${query}`;

                const isMobileValue = isMobile();
                if (isMobileValue) {
                    url += `&mobile=${isMobileValue}`
                }
                const isTablet = isTabletOrIpad();
                if (isTablet) {
                    url += `&tablet=${isTablet}`
                }
                if (gClid) {
                    url += '&gclid=' + encodeURIComponent(gClid);
                }
                if (gSource) {
                    url += '&gs=' + encodeURIComponent(gSource);
                }
                if (gMedium) {
                    url += '&gm=' + encodeURIComponent(gMedium);
                }
                if (gCampaign) {
                    url += '&gc=' + encodeURIComponent(gCampaign);
                }
                if (ApexChat.nonceValue) {
                    tracker.nonce = ApexChat.nonceValue;
                }
                tracker.src = url;
                tracker.async = true;
                tracker.onload = function () {
                    // save the visitor id for future sessions
                    // this will be the existing visitor id, or if the id sent in was 0, will be new
                    createCookie(VISITOR_ID_COOKIE, PingResponse, 365);
                };
                document.body.appendChild(tracker);
                // run the invite
                if (ApexChat.Invitation.ready) {
                    // run the invite
                    ApexChat.Invitation.ready();
                }
            } else {
                // for anyone with a direct link to apexchat.js - backward compatibility- Tech Support has been giving direct link to apexchat.js for speed issues in the past
                invitation.src =
                    `${domain}scripts/invitation2.ashx?company=${companyId}&suppressInitialize=false` +
                    `&chatId=${readCookieValue(
                        CHATID_COOKIE
                    )}&visitorId=${visitorId}&agentAliasId=${agentAliasId}&operatorId=${operatorId}&profileId=${profileId}&gclid=${encodeURIComponent(gClid)}&gs=${encodeURIComponent(gSource)}&gm=${encodeURIComponent(gMedium)}&gc=${encodeURIComponent(gCampaign)}&originalReferrer=${encodeURIComponent(
                        document.referrer
                    ).substring(0, 500)}${query}`;
                invitation.async = true;
                if (ApexChat.nonceValue) {
                    invitation.nonce = ApexChat.nonceValue;
                }
                head.insertBefore(invitation, head.firstChild);
            }
        };

        var head = document.getElementsByTagName('head')[0] || document.documentElement;
        var invitation = document.createElement('script');
        const allScripts = document.getElementsByTagName('script');
        var tracker = document.createElement('script');
        var companyId = '';
        var query = '';
        var domain = `${document.location.protocol}//www.apexchat.net/`;

        for (let i = 0; i < allScripts.length; i++) {
            const s = allScripts[i];
            if (
                s &&
                s.src &&
                (s.src.indexOf('invitation.ashx') > -1 ||
                    s.src.indexOf('api/invitations') > -1 ||
                    s.src.indexOf('apexchat.js') > -1 ||
                    s.src.indexOf('index.bundle') > -1 ||
                    s.src.indexOf('static.js') > -1 ||
                    s.src.indexOf('invitation.js') > -1)
            ) {
                const a = document.createElement('a');
                a.href = s.src;
                if (s.nonce) {
                    ApexChat.nonceValue = s.nonce;
                    // eslint-disable-next-line no-undef, camelcase
                    __webpack_nonce__ = s.nonce;
                }
                if (a.host) {
                    domain = `${document.location.protocol}//${a.host}/`;
                } else {
                    domain = '';
                }
                const parts = a.search.substring(1).split('&');
                for (let j = 0; j < parts.length; j++) {
                    const keyValues = parts[j].split('=');
                    if (keyValues[0].toLowerCase() == 'company') {
                        companyId = keyValues[1];
                    } else {
                        query += `&${parts[j]}`;
                    }
                }
                break;
            }
        }
        var VISITOR_ID_COOKIE = 'livechat_visitor_id';
        // var VISITOR_HISTORY_COOKIE = 'livechat_visitor_history';
        const AGENT_ALIAS_ID_COOKIE = 'livechat_agent_alias_id';
        const OPERATOR_ID_COOKIE = 'livechat_operator_id';
        const PROFILE_ID_COOKIE = 'livechat_profile_id';
        var CHATID_COOKIE = 'livechat_chat_id';

        // set on load of the slim init
        // var visitorGuid = readCookie(VISITOR_HISTORY_COOKIE) || '';
        // set on load of the ping
        var visitorId = readCookieValue(VISITOR_ID_COOKIE) || 0;
        // set after load of the slim init
        var agentAliasId = readCookieValue(AGENT_ALIAS_ID_COOKIE) || 0;
        var operatorId = readCookieValue(OPERATOR_ID_COOKIE) || 0;
        var profileId = readCookieValue(PROFILE_ID_COOKIE) || 0;

        if (ApexChat.slimInit) {
            if (!profileId) {
                profileId = ApexChat.slimInit.profileId;
            }
        }

        // google ad - normally has a utm_source, but for the "automatic" ones may have the gclid
        // https://support.google.com/analytics/answer/1033981?hl=en
        // var isGoogleAdSource = window.location.href.indexOf('gclid=') > -1 || window.location.href.indexOf('utm_source=') > -1
        // also, let's pull a few params
        var gSource = fromQueryString('utm_source');
        var gMedium = fromQueryString('utm_medium');
        var gCampaign = fromQueryString('utm_campaign');
        var gClid = fromQueryString('gclid');

        // TODO: split this into 2 steps. step #1 grabs the invite ui from a cache frontend
        // and step 2 pings back to the main server to log it
        // note that we still have to set some info (profile id, operator id, visitor id, agent alias)
        // and pass those along to the CDN to load up the right info

        if (window.ApexChat && window.ApexChat.slimInit && window.ApexChat.slimInit.useCdn) {
            // when using the cdn, no extra query params are needed on the script load
            invitation.src = window.ApexChat.slimInit.cdnUrl;
            invitation.async = true;
            invitation.onload = function () {
                invitationConfiguration();
            };
            head.insertBefore(invitation, head.firstChild);
        } else {
            invitationConfiguration();
        }
    } catch (e) {
        window.ApexChat.invitationv2run = false;
        window.setTimeout(() => {
            ApexChatInit();
        }, 1000);

        if (window && window.console) {
            // window.console.error(e);
        }
    }
};
// window.ApexChat.init();
